<template>
    <v-app-bar color="primary" dark>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>{{ $t('companyName') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text :class="{ 'v-btn--active': activeMenu === 'home' }" to="/" @click="setActiveMenu('home')">
            {{ $t('home') }} </v-btn>
        <v-btn text :class="{ 'v-btn--active': activeMenu === 'about' }" to="/about" @click="setActiveMenu('about')">
            {{ $t('about') }} </v-btn>

        <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" text :class="{ 'v-btn--active': activeMenu === 'products' }">
                    {{ $t('products') }}
                </v-btn>
            </template>
            <v-list class="horizontal-menu">
                <v-list-item to="/products/audit">
                    <v-icon class="mr-2">mdi-text-box-check-outline</v-icon>
                    <v-list-item-title>审计评估</v-list-item-title>
                </v-list-item>
                <v-list-item to="/products/tax">
                    <v-icon class="mr-2">mdi-cash-check</v-icon>
                    <v-list-item-title>税务筹划</v-list-item-title>
                </v-list-item>
                <v-list-item to="/products/accounting">
                    <v-icon class="mr-2">mdi-abacus</v-icon>
                    <v-list-item-title>会计理账</v-list-item-title>
                </v-list-item>
                <v-list-item to="/products/consulting">
                    <v-icon class="mr-2">mdi-account-question-outline</v-icon>
                    <v-list-item-title>管理咨询</v-list-item-title>
                </v-list-item>
                <v-list-item to="/products/hongkong">
                    <v-icon class="mr-2">mdi-office-building</v-icon>
                    <v-list-item-title>香港业务</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-btn text :class="{ 'v-btn--active': activeMenu === 'contact' }" to="/contact"
            @click="setActiveMenu('contact')">
            {{ $t('contact') }} </v-btn>
    </v-app-bar>


</template>

<script setup>
import { ref, computed, watch, inject, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
const drawer = ref(false)
const language = ref('zh') // 默认语言
const languages = ref([
    { value: 'en', text: 'English' },
    { value: 'zh', text: '中文' }
])
const activeMenu = ref('')

const { locale } = useI18n()
const router = useRouter()
const route = useRoute()

const currentLanguage = computed(() => {
    const currentLang = languages.value.find(lang => lang.value === language.value)
    return currentLang ? currentLang.text : 'Language'
})

const changeLanguage = (lang) => {
    locale.value = lang
    language.value = lang
}

const setActiveMenu = (menu) => {
    activeMenu.value = menu;
};


// 监听路由变化，渲染对应导航
watch(route, (newRoute) => {
    console.log('Route changed to:', newRoute.path);
    const match = newRoute.path.match(/(?<=^\/)\w+(?=$|\/)/);
    let nav = ref('home')
    if (match) {
        nav = match[0];
    }
    setActiveMenu(nav)
});

</script>

<style scoped>
/* 自定义样式 */
.v-app-bar {
    padding-left: 5%;
    padding-right: 5%;
}

.v-toolbar-title {
    font-family: 'Linhai', sans-serif;
    font-size: 36px;
    /* margin-inline-start: 0px; */
    /* 调整标题文字大小 */
}

.v-btn-toggle {
    margin-right: 16px;
}

.v-btn {
    font-size: 14px;
    /* 调整按钮文字大小 */
}

.v-list-item {
    font-size: 14px;
    /* 调整列表项文字大小 */
    display: flex;
    align-items: center;
    /* 垂直居中对齐 */
}

.v-icon {
    margin-right: 8px;
    /* 调整图标和文字的间距 */
}

/* 横向布局样式 */
.horizontal-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 8px;
}

.horizontal-menu .v-list-item {
    margin-right: 16px;
    /* 调整列表项之间的间距 */
    padding: 8px 12px;
    /* 调整列表项的内边距 */
}

.horizontal-menu .v-list-item:last-child {
    margin-right: 0;
    /* 最后一个列表项不需要右边距 */
}

/* 激活菜单样式
.active-menu {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
} */
</style>